"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.typed.uint8-array");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _xlsx = _interopRequireDefault(require("xlsx"));

var _default = {
  methods: {
    readExcelFileToJson: function () {
      var _readExcelFileToJson = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(file) {
        var excelData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                excelData = null;
                _context.next = 3;
                return new Promise(function (resolve, reject) {
                  try {
                    var reader = new FileReader();

                    reader.onload = function () {
                      try {
                        var result = {};
                        var fileData = new Uint8Array(reader.result);

                        var workbook = _xlsx.default.read(fileData, {
                          type: 'array',
                          cellDates: true
                        });

                        workbook.SheetNames.forEach(function (sheetName) {
                          var roa = _xlsx.default.utils.sheet_to_json(workbook.Sheets[sheetName], {
                            raw: true
                          });

                          if (roa.length > 0) {
                            result[sheetName] = roa;
                          }
                        });
                        resolve(result);
                      } catch (e) {
                        reject(e);
                      }
                    };

                    reader.readAsArrayBuffer(file);
                  } catch (e) {
                    reject(e);
                  }
                }).then(function (result) {
                  excelData = result;
                }).catch(function (error) {
                  console.log(error);
                });

              case 3:
                return _context.abrupt("return", excelData);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function readExcelFileToJson(_x) {
        return _readExcelFileToJson.apply(this, arguments);
      }

      return readExcelFileToJson;
    }()
  }
};
exports.default = _default;